var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideMode-Viewer",on:{"click":_vm.handleClickViewer}},[_c('div',{staticClass:"slideMode-Viewer_content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.pages[_vm.page])}})])])}
var staticRenderFns = []

export { render, staticRenderFns }